import { state_codes } from '../globals.js';
import Swal from "sweetalert2";
import { push } from 'svelte-spa-router';


export function formatPhoneNumber(phoneNumberString) {
	var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
	var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
	if (match) {
		var intlCode = (match[1] ? '+1 ' : '');
		return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
	}
	return null;
}

export function formatDate(date) {
	let today;
	if (typeof date === 'object') today = new Date(date);
	else today = new Date((date || '').includes('T') ? date : (date || '').replaceAll('-', '/'));
	const dd = String(today.getDate()).padStart(2, '0');
	const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	const yyyy = today.getFullYear();
	const formatted_date = mm + '/' + dd + '/' + yyyy;
	return formatted_date;
}

export function formatDateAndTime(datetime) {
	if (datetime) {
		function format_two_digits(n) { return n < 10 ? '0' + n : n; }
		const date_obj = new Date(datetime);
		const dd = String(date_obj.getDate()).padStart(2, '0');
		const mm = String(date_obj.getMonth() + 1).padStart(2, '0'); //January is 0!
		const yyyy = date_obj.getFullYear();
		const hh = format_two_digits(date_obj.getHours());
		const mi = format_two_digits(date_obj.getMinutes());
		const ss = format_two_digits(date_obj.getSeconds());
		return mm + '/' + dd + '/' + yyyy + ' ' + hh + ':' + mi + ':' + ss;
	} else {
		return '';
	}
}

export function getFormatDateByOffset(offset) {
	let date = new Date();
	date.setDate(date.getDate() + offset);
	let dd = String(date.getDate()).padStart(2, '0');
	let mm = String(date.getMonth() + 1).padStart(2, '0');
	let yyyy = date.getFullYear();
	date = mm + '-' + dd + '-' + yyyy.toString().substring(2);
	return date;
}

export function getFullState(state_code) {
	if (state_code.length === 2) {
		const state = Object.keys(state_codes).find(item => state_codes[item] == state_code);
		return state;
	} else {
		return state_code
	}
}

export function get_job_status(job_status) {
	switch(job_status) {
			case 'pending':
					return 'Pending';
			case 'card_declined':
					return 'Card Declined';
			case 'assigned':
					return 'Assigned';
			case 'not_assigned':
					return 'Not Assigned';
			case 'completed':
					return 'Completed';
			case 'approved':
					return 'Approved';
			case 'unpaid':
					return 'Unpaid';
			case 'charged':
					return 'Charged';
			case 'refunded':
					return 'Approved';
			default:
					return 'Pending';
	}
}

export function jobStatsToNum(status) {
	if (status === 'not_assigned') {
		return [1, 'Not Assigned'];
	} else if (status === 'assigned') {
		return [2, 'Assigned'];
	} else if (status === 'completed') {
		return [3, 'Completed'];
	} else if (status === 'approved') {
		return [4, 'In Progress'];
	} else if (status === 'refunded') {
		return [4, 'Refunded'];
	} else if (status === 'card_declined') {
		return [5, 'Card Declined'];
	} else if (status === 'charged') {
		return [6, 'Charged'];
	} else if (status === 'rated') {
		return [7, 'Rated'];
	} else if (status === 'unpaid') {
		return [4, 'Unpaid'];
	} else {
		return 0;
	}
}

export function get_possible_roles(role, plan_type) {
	if (role === 'landscaper' || role === 'admin') {
		return ["Admin", "Manager", plan_type === 'basic' ? "Lead" : "Client", "Contractor", "Employee", "Vendor", "Applicant"];
	} else if (role === 'manager') {
		return [plan_type === 'basic' ? "Lead" : "Client", "Contractor", "Employee", "Vendor", "Applicant"];
	} else {
		return [];
	}
}

export function check_access_able(myself_role, open_role) {
	if (myself_role === 'landscaper') return true;
	if (myself_role === 'landscaper' || myself_role === 'admin') {
		if (open_role !== 'landscaper') return true;
		else return false;
	}
	else {
		if (open_role === 'landscaper' || open_role === 'admin') return false;
		return true;
	}
}

export let formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

export function handle_not_subscribed(is_authenticated=false, is_domain_expired=false) {
	const title = is_authenticated && is_domain_expired ? "Domain expired" : "Website inactive";
	Swal.fire({
		title: title,
		text: '',
		buttonsStyling: true,
		confirmButtonClass: "button",
		confirmButtonText: 'OK',
		cancelButtonText: "Cancel",
		showCancelButton: true,
		icon: "warning"
	}).then(async (e) => {
		if (e.isConfirmed) {
			if (is_authenticated) {
				push('#/Choose_Plan');
			} else {
				let subdomain = localStorage.getItem('HoyFreeDoMainName');
				push(`#/Choose_Plan?domain_name=${subdomain}`);
			}
		}
	});
}

export let sort_functions = {
	"p": (el1, el2) => {
		let nameA = el1.toString().toUpperCase();
		let nameB = el2.toString().toUpperCase();
		if (nameA[0] === '$') {
			nameA = parseFloat(nameA.replace('$',''));
			nameB = parseFloat(nameB.replace('$',''));
		}
		if ((nameA < nameB || nameA === '-')) { return -1; }
		if ((nameA > nameB || nameB === '-')) { return 1; }
		return 0;
	},
}

export function compare_plans(current_plan, new_plan) {
	const plans = { free: 4, prime: 3, pro: 2, basic: 1 };
	return plans[new_plan] < plans[current_plan];
}

const getNextMonth = (date) => {
	const origin_date = new Date(date);
	if (origin_date.getMonth() == 11) {
		return new Date(origin_date.getFullYear() + 1, 0, origin_date.getDate());
	} else {
		return new Date(origin_date.getFullYear(), origin_date.getMonth() + 1, origin_date.getDate());
	}
}

export function get_next_plan_date(paid_at, plan_freq) {
	if (plan_freq === 'month') {
		return getNextMonth(paid_at);
	} else {
		const paid_date = new Date(paid_at);
		const today = new Date();
		const pre_date = new Date(today.getFullYear(), today.getMonth(), paid_date.getDate());
		if (paid_date.getDate() <= today.getDate()) {
			return getNextMonth(pre_date);
		} else {
			return pre_date;
		}
	}
}